// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1fuFq","noInteraction":"EventWrapper_noInteraction__QW8oG","pointerPassthrough":"EventWrapper_pointerPassthrough__1iKkP"};